export const ADDING_CARRIER = "ADDING_CARRIER";
export const CARRIER_SUCCESS = "CARRIER_SUCCESS";
export const CARRIER_ERROR = "CARRIER_ERROR";
export const GET_COUNTRIES = "GET_COUNTRIES";
export const SIDE_LOAD = "SIDE_LOAD";
export const SIDE_LOAD_ERROR = "SIDE_LOAD_ERROR";
